import { ADTablePage } from '@/features/end-of-lease/ad-table/ad-table-page';
import { createFileRoute } from '@tanstack/react-router';

import { parseOptionalPage } from '@/lib/urlUtils';

export const Route = createFileRoute('/lease/projects/$projectId/ad-table')({
    component: ADTablePage,
    validateSearch: (search: Record<string, unknown>) => ({
        page: parseOptionalPage(search.page),
        filter: typeof search.filter === 'string' ? search.filter : undefined,
    }),
});
